<ng-container content>
    <div class="settings-page">
        <aumico-design-settings-page
            [organizationSettings]="organizationSettingsToBeSaved"
            (onOrganizationSettingsChanged)="onOrganizationSettingsChanged($event)"
            (onSave)="saveButtonClicked()"
        ></aumico-design-settings-page>
    </div>
</ng-container>
<ng-template #footerTemplate>
    <aum-action-bar-pure
        nextButtonText="{{'aumico_button_save' | i18next}}"
        [nextButtonAction]="saveButtonClicked"
        [nextButtonDisabled]="false"
    ></aum-action-bar-pure>
</ng-template>
